import React from 'react';

// Hide an inactive kept-mounted panel without display:none, which would collapse descendants to
// zero size and make their ResizeObservers (e.g. MUI TextareaAutosize) loop on re-show.
// height:0 + overflow:hidden keeps descendants laid out (so ResizeObservers stay stable) while
// stopping the absolutely-positioned panel from extending the page's scroll height (ENG-11532).
const HIDDEN_KEPT_MOUNTED_STYLE: React.CSSProperties = {
  display: 'block', // overrides the `hidden` attribute's UA display:none
  visibility: 'hidden',
  position: 'absolute',
  top: 0,
  left: 0,
  height: 0,
  overflow: 'hidden',
  pointerEvents: 'none',
};

const CustomTabPanel: React.FC<{
  children?: React.ReactNode;
  index: number;
  value: number;
  customStyle?: React.CSSProperties;
  keepMounted?: boolean;
}> = ({ children, value, index, customStyle, keepMounted }): React.ReactElement => {
  const isActive = value === index;
  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{
        width: '100%',
        ...(isActive ? customStyle : {}),
        ...(keepMounted && !isActive ? HIDDEN_KEPT_MOUNTED_STYLE : {}),
      }}
    >
      {(isActive || keepMounted) && <>{children}</>}
    </div>
  );
};
export default CustomTabPanel;
